import { EnumHelper, Model } from "@singularsystems/neo-core";
import { NeoGrid } from "@singularsystems/neo-react";
import { CatalogueEntry } from "../CatalogueEntry";
import DataCache from "../../../Services/DataCache";
import * as CatalogueRoles from "../../../Models/Security/CatalogueRoles"
import { IGenericApiClient } from "../../../ApiClients/Catalogues/GenericApiClient";
import { Catalogue } from "@singularsystems/neo-react-services";
import { AppService, DomainTypes, Types } from "../../../DomainTypes";
import AuthoriseButton from "../../../Components/AuthoriseButton";
import CatalogueAuthorisation from "../CatalogueAuthorisation";
import { NotificationDuration } from "../../../../App/Models/NotificationDuration";
import MergeTemplate from "../../../Models/Catalogue/General/MergeTemplate";
import { CatalogueColumn } from "@singularsystems/neo-react-services/dist/Catalogue/Components/CatalogueFormGroup";
import ContactTypeCatalogueEntry from "./ContactTypeCatalogueEntry";
import { MergeTemplateType } from "../../../Models/Catalogue/General/MergeTemplateType";

export default class MergeTemplateCatalogueEntry extends CatalogueEntry<MergeTemplate> {

    constructor() {
        super("Merge Templates", MergeTemplate);

        this.modalSize = "lg";
    }

    private documentsApiClient = AppService.get(DomainTypes.ApiClients.Documents);
    private notifications = AppService.get(Types.Neo.UI.GlobalNotifications);

    public get editRole() {
        return CatalogueRoles.MergeTemplate.Edit;
    }

    public getCacheEntry(cache: DataCache) {
        return cache.mergeTemplates;
    }

    public getSaveEndpoint(apiClient: IGenericApiClient) {
        return apiClient.saveMergeTemplates;
    }

    public renderRow(item: MergeTemplate, meta: Model.TransformMetaType<MergeTemplate>) {
        return (
            <NeoGrid.RowGroup expandProperty={meta.isExpanded}>
                <NeoGrid.Row>
                    <NeoGrid.Column bind={meta.mergeTemplateName} />
                    <NeoGrid.Column bind={meta.isTermsAndConditions}
                        label="T+Cs?"
                        headerTooltip="Indicates that the file is a terms and conditions or main agreement template." />
                    <NeoGrid.Column bind={meta.forDwtExempt}
                        label="DWT Exempt?"
                        headerTooltip="Allows templates to be filtered by whether an investor is dwt exempt or not." />
                    <NeoGrid.Column bind={meta.forQualifyingPurpose}
                        label="QP?"
                        headerTooltip="Allows templates to be filtered by whether an investment is ticked qualifying purpose or not." />
                    <NeoGrid.Column bind={meta.productTypeId}
                        select={{ itemSource: this.dataCache.productTypes }} />
                    <NeoGrid.Column bind={meta.mergeTemplateType}
                        select={{ items: EnumHelper.asList(MergeTemplateType) }} />

                    <NeoGrid.Column bind={meta.templateFileId}
                        fileProps={{
                            uploadEndpoint: this.documentsApiClient.getUploadDocumentUrl(),
                            downloadEndpointAsync: this.documentsApiClient.getFileDownloadUrl,
                            fileDescriptorProperty: meta.templateFile,
                            allowedExtensions: [".docx"]
                        }} />

                    <NeoGrid.ButtonColumn>
                        <AuthoriseButton
                            className="me-2"
                            viewModel={CatalogueAuthorisation.authorisationVM}
                            currentRecord={item}
                            authoriseRoleName={CatalogueRoles.MergeTemplate.Authorise}
                            onDelete={() => {
                                this.editState.editList.removeWithoutTracking(item);
                                this.dataCache.mergeTemplates.expire();
                            }} />
                    </NeoGrid.ButtonColumn>
                    <Catalogue.ButtonColumn
                        deleteButton={{
                            onClick: () => {
                                if (item.isNew) {
                                    this.editState.editList.removeWithoutTracking(item);
                                }
                                else {
                                    item.isPendingDelete = !item.isPendingDelete;
                                    if (item.isPendingDelete) {
                                        this.notifications.addInfo("Mark Deleted", `Please click save to action this request.`, NotificationDuration.Standard);
                                    }
                                }
                            },
                            icon: item.isPendingDelete ? "trash-restore" : "trash",
                            tooltip: item.isPendingDelete ? "Stop the merge template from being removed when authorised."
                                                        : "Mark the merge template to be removed when authorised."
                        }} />
                </NeoGrid.Row>
                <NeoGrid.ChildRow>
                    <NeoGrid.Grid items={item.signatories} addButton={{ text: "Add Signatory" }}>
                        {(signatory, meta) => (
                            <NeoGrid.Row>
                                <NeoGrid.Column bind={meta.description} />
                                <CatalogueColumn bind={meta.contactTypeId} catalogueType={ContactTypeCatalogueEntry} />
                                <NeoGrid.ButtonColumn showDelete />
                            </NeoGrid.Row>
                        )}
                    </NeoGrid.Grid>
                </NeoGrid.ChildRow>
            </NeoGrid.RowGroup>
            
        )
    }
}